import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { useAccountSelector } from './useAccountSelector';

export const useRedirectToSummaryAfterAccountSubmit = () => {
  const shouldNavigateToSummary = useSelector((state: any) => state.app.redirectToSummaryAfterAccountSubmit);
  const { account } = useAccountSelector();
  const navigate = useNavigate();

  useEffect(() => {
    if (shouldNavigateToSummary) {
      if (account?.accountId) {
        window.gtag('event', 'account', {
          accountId: account?.accountId,
        });
      }

      if (account?.type.isEntity) {
        navigate('/complete-account');

        return;
      }

      navigate('/main/summary');
    }
  }, [shouldNavigateToSummary]);
};
